"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendIntersect = exports.extendUnion = exports.extendObject = exports.extendIntegerType = exports.extendNumberType = exports.extendStringType = exports.mergeOptions = exports.extractOptions = exports.extractBasicOptions = void 0;
const typebox_1 = require("@sinclair/typebox");
function extractBasicOptions(options) {
    return {
        title: options.title,
        description: options.description,
    };
}
exports.extractBasicOptions = extractBasicOptions;
function extractOptions(options) {
    const data = Object.assign({}, options);
    delete data.$id;
    // eslint-disable-next-line security/detect-object-injection
    delete data[typebox_1.Kind];
    delete data["$id"];
    delete data["type"];
    delete data["kind"];
    return data;
}
exports.extractOptions = extractOptions;
function mergeOptions(...options) {
    return Object.assign({}, ...options.map((f) => f ?? {}));
}
exports.mergeOptions = mergeOptions;
/**
 * Tailor an existing string with new options.
 *
 * Typically used to change the title, but keep the validation.
 *
 * @param original
 * @param options
 * @returns
 */
function extendStringType(original, options) {
    if (options == undefined) {
        return original;
    }
    return typebox_1.Type.String(mergeOptions(extractOptions(original), options));
}
exports.extendStringType = extendStringType;
/**
 * Tailor an existing number with new options.
 *
 * Typically used to change the title, but keep the validation.
 *
 * @param original
 * @param options
 * @returns
 */
function extendNumberType(original, options) {
    if (options == undefined) {
        return original;
    }
    return typebox_1.Type.Number(mergeOptions(extractOptions(original), options));
}
exports.extendNumberType = extendNumberType;
/**
 * Tailor an existing integer with new options.
 *
 * Typically used to change the title, but keep the validation.
 *
 * @param original
 * @param options
 * @returns
 */
function extendIntegerType(original, options) {
    if (options == undefined) {
        return original;
    }
    return typebox_1.Type.Integer(mergeOptions(extractOptions(original), options));
}
exports.extendIntegerType = extendIntegerType;
function extendObject(object, options) {
    return typebox_1.Type.Object(object.properties, mergeOptions(extractOptions(object), options));
}
exports.extendObject = extendObject;
function extendUnion(object, options) {
    return typebox_1.Type.Union(object.anyOf, mergeOptions(extractOptions(object), options));
}
exports.extendUnion = extendUnion;
// TODO: Deprecate not supported
function extendIntersect(intersect, _options) {
    return intersect;
    // return Type.Intersect<T>(
    //     Object.values(intersect.properties) as T[],
    //     mergeOptions(extractOptions(intersect), options)
    // );
}
exports.extendIntersect = extendIntersect;
